/* ============================================================================
   WLB Reichweiten-Simulator — Scene
   Recoloured LottieFiles "Cycling" rider (WeLikeBikes teal) over a responsive
   landscape. A "Fahrt simulieren" PLAY button runs a real discharge: the battery
   drains 100 %→0 % over a duration proportional to the range (bigger range / Akku
   = longer ride), the km counter counts up the distance covered, and when the
   battery is empty the motor assist cuts → the rider visibly slows (ride continues
   without support). Idle shows full battery + the estimated range; replayable.
   Public API unchanged: WlbSimulatorScene.create(host,state,result) -> {update,stop}.
   Animation data is window.WLB_CYCLING_DATA (asset wlb-cycling.js).
   ========================================================================== */
window.WlbSimulatorScene = (function () {

  var W = 900, H = 440, GROUND_Y = 330;

  var LABEL_MODE = { 'eco-plus': 'Eco+', eco: 'Eco', tour: 'Tour', 'tour-plus': 'Tour+', sport: 'Sport', emtb: 'eMTB', turbo: 'Turbo', auto: 'Auto' };
  var LABEL_TERRAIN = { flach: 'Flach', huegelig: 'Hügelig', bergig: 'Bergig' };
  var LABEL_WIND = { rueckenwind: 'Rückenwind', windstill: 'Windstill', gegenwind: 'Gegenwind' };

  function cs(v) { return Math.max(0.35, Math.min(2.2, v)); }

  function ensureLottie(cb) {
    if (window.lottie) return cb();
    var ex = document.getElementById('wlb-lottie-script');
    if (ex) { ex.addEventListener('load', cb); return; }
    var s = document.createElement('script');
    s.id = 'wlb-lottie-script';
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
    s.onload = cb;
    document.head.appendChild(s);
  }

  function hillY(terrain, x, phase) {
    var amp = terrain === 'bergig' ? 46 : (terrain === 'huegelig' ? 24 : 8);
    var k = terrain === 'bergig' ? 0.013 : 0.009;
    return GROUND_Y - (Math.sin((x + phase * 60) * k) * 0.6 + Math.sin((x + phase * 60) * k * 0.4) * 0.4) * amp;
  }
  function groundPath(terrain, phase) {
    var d = 'M0 ' + H + ' L0 ' + hillY(terrain, 0, phase).toFixed(1);
    for (var x = 0; x <= W; x += 30) d += ' L' + x + ' ' + hillY(terrain, x, phase).toFixed(1);
    return d + ' L' + W + ' ' + H + ' Z';
  }

  function speedFactorOf(state) {
    var terrSlow = state.terrain === 'bergig' ? 0.72 : (state.terrain === 'huegelig' ? 0.88 : 1);
    var windSlow = state.wind === 'gegenwind' ? 0.82 : (state.wind === 'rueckenwind' ? 1.14 : 1);
    return ((state.speed || 22) / 22) * terrSlow * windSlow;
  }

  function create(host, initialState, initialResult) {
    host.innerHTML = ''
      + '<div class="wlbsim-scene wlbsim-scene-3d">'
      +   '<div class="wlbsim-batt-row">'
      +     '<button type="button" class="wlbsim-play" id="wlbsim-play"><span class="ic">▶</span><span class="tx">Fahrt simulieren</span></button>'
      +     '<div class="wlbsim-batt-bar"><div class="wlbsim-batt-fill"></div></div>'
      +     '<div class="wlbsim-batt-pct">100%</div>'
      +     '<div class="wlbsim-batt-akku">' + initialState.akku + ' Wh</div>'
      +     '<button type="button" class="wlbsim-exit" id="wlbsim-exit" hidden><span class="ic">✕</span><span class="tx">Live-Ansicht</span></button>'
      +   '</div>'
      +   '<div class="wlbsim-3d-stage">'
      +     '<svg class="wlbsim-bg" viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="xMidYMid slice">'
      +       '<defs>'
      +         '<linearGradient id="wlbsim-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#BAE6FD"/><stop offset="100%" stop-color="#F1F8F6"/></linearGradient>'
      +         '<linearGradient id="wlbsim-grd" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#5BC0BE" stop-opacity="0.9"/><stop offset="100%" stop-color="#0F766E"/></linearGradient>'
      +       '</defs>'
      +       '<rect x="0" y="0" width="' + W + '" height="' + H + '" fill="url(#wlbsim-sky)"/>'
      +       '<g class="wlbsim-hills" opacity="0.35"></g>'
      +       '<path class="wlbsim-ground" fill="url(#wlbsim-grd)"></path>'
      +       '<g class="wlbsim-trail"></g>'
      +       '<g class="wlbsim-wind"></g>'
      +       '<g class="wlbsim-snow"></g>'
      +     '</svg>'
      +     '<div class="wlbsim-rider"></div>'
      +     '<div class="wlbsim-chips">'
      +       '<span class="wlbsim-chip" data-c="mode"></span>'
      +       '<span class="wlbsim-chip" data-c="terrain"></span>'
      +       '<span class="wlbsim-chip" data-c="wind"></span>'
      +       '<span class="wlbsim-chip" data-c="temp"></span>'
      +       '<span class="wlbsim-chip" data-c="speed"></span>'
      +     '</div>'
      +     '<div class="wlbsim-counter-badge">'
      +       '<div class="wlbsim-counter-label">LIVE-SCHÄTZUNG · REICHWEITE</div>'
      +       '<div class="wlbsim-counter-num">0<span>km</span></div>'
      +       '<div class="wlbsim-counter-time"></div>'
      +     '</div>'
      +     '<div class="wlbsim-consume"></div>'
      +     '<div class="wlbsim-empty-badge">⚡ Akku leer · ab hier ohne Motor­unterstützung</div>'
      +   '</div>'
      + '</div>';

    var els = {
      play:       host.querySelector('#wlbsim-play'),
      battFill:   host.querySelector('.wlbsim-batt-fill'),
      battPct:    host.querySelector('.wlbsim-batt-pct'),
      battAkku:   host.querySelector('.wlbsim-batt-akku'),
      hills:      host.querySelector('.wlbsim-hills'),
      ground:     host.querySelector('.wlbsim-ground'),
      trail:      host.querySelector('.wlbsim-trail'),
      wind:       host.querySelector('.wlbsim-wind'),
      snow:       host.querySelector('.wlbsim-snow'),
      rider:      host.querySelector('.wlbsim-rider'),
      counterNum: host.querySelector('.wlbsim-counter-num'),
      counterLbl: host.querySelector('.wlbsim-counter-label'),
      counterTime:host.querySelector('.wlbsim-counter-time'),
      exit:       host.querySelector('#wlbsim-exit'),
      chips:      host.querySelector('.wlbsim-chips'),
      consume:    host.querySelector('.wlbsim-consume'),
      empty:      host.querySelector('.wlbsim-empty-badge')
    };

    // Zeit-Chip-Stil direkt hier setzen (Inline-Style schlägt die evtl. gecachte
    // Inline-CSS-Klasse der Seite → sofort sichtbar nach JS-Asset-Update).
    var TIME_CHIP = 'display:inline-block;font-size:12px;font-weight:800;color:#021530;background:rgba(255,255,255,0.92);border:1px solid rgba(2,21,48,0.06);padding:4px 10px;border-radius:8px;margin-top:8px;letter-spacing:0.01em;box-shadow:0 1px 3px rgba(2,21,48,0.14)';
    function showTime(txt) { if (els.counterTime) { els.counterTime.style.cssText = TIME_CHIP; els.counterTime.textContent = txt; } }
    function hideTime() { if (els.counterTime) { els.counterTime.textContent = ''; els.counterTime.style.cssText = 'display:none'; } }

    var state  = Object.assign({}, initialState);
    var result = Object.assign({}, initialResult);
    var raf = 0, lastNow = performance.now(), phase = 0;
    var counterStart = performance.now(), counterFrom = 0, counterTo = result.km || 0;
    var sf = speedFactorOf(state);

    // Discharge play state
    var mode = 'idle';        // idle | playing | done
    var playStart = 0, playDur = 6, simHoursTotal = 0;

    var lottieAnim = null;
    ensureLottie(function () {
      if (!window.lottie || !window.WLB_CYCLING_DATA || !els.rider) return;
      lottieAnim = window.lottie.loadAnimation({
        container: els.rider, renderer: 'svg', loop: true, autoplay: true,
        animationData: window.WLB_CYCLING_DATA,
        rendererSettings: { preserveAspectRatio: 'xMidYMax meet' }
      });
      lottieAnim.setSpeed(cs(sf));
    });
    function setLottie(v) { if (lottieAnim) { try { lottieAnim.setSpeed(cs(v)); } catch (e) {} } }

    function rangeKm() { return Math.max(1, result.km || 0); }
    function tripHours() { return rangeKm() / (state.speed || 22); }
    // Feste Zeitraffung: 1 reale Sekunde = 1 Fahrstunde (immer 1:1). Größerer Akku /
    // mehr Reichweite = längere Fahrt = proportional längere Animation. Winziger
    // Mindestwert nur, damit sehr kurze Fahrten nicht in einem Blitz vorbei sind.
    function durationFor() { return Math.max(0.8, tripHours()); }
    function scaleLabel() { return '1 Sek ≈ 1 Std'; }

    function resetPlay() {
      mode = 'idle';
      els.play.classList.remove('is-running', 'is-done');
      els.play.querySelector('.ic').textContent = '▶';
      els.play.querySelector('.tx').textContent = 'Fahrt simulieren';
      if (els.exit) els.exit.hidden = true;
      els.empty.classList.remove('show');
      els.counterLbl.textContent = 'LIVE-SCHÄTZUNG · REICHWEITE';
      hideTime();
      counterFrom = (els.counterNum.firstChild ? +els.counterNum.firstChild.nodeValue || 0 : 0);
      counterTo = rangeKm(); counterStart = performance.now();
      setLottie(sf);
    }

    els.play.addEventListener('click', function () {
      if (mode === 'playing') return;
      mode = 'playing'; playStart = performance.now();
      simHoursTotal = tripHours(); playDur = durationFor();
      els.play.classList.add('is-running'); els.play.classList.remove('is-done');
      els.play.querySelector('.ic').textContent = '●';
      els.play.querySelector('.tx').textContent = 'läuft …';
      if (els.exit) els.exit.hidden = false;
      els.empty.classList.remove('show');
      els.counterLbl.textContent = 'GEFAHRENE STRECKE';
      setLottie(sf);
    });

    // Simulation verlassen → zurück zur Live-Schätzung (ohne Eingabe zu ändern).
    if (els.exit) els.exit.addEventListener('click', function () { resetPlay(); });

    function buildScenery() {
      els.hills.innerHTML = '<path d="M0 ' + (GROUND_Y - 20) + ' Q220 ' + (GROUND_Y - 90) + ' 440 ' + (GROUND_Y - 30)
        + ' T' + W + ' ' + (GROUND_Y - 40) + ' L' + W + ' ' + H + ' L0 ' + H + ' Z" fill="#94A3B8"/>';
      els.hills.setAttribute('opacity', state.terrain === 'flach' ? '0.18' : '0.35');
      var t = '';
      for (var i = 0; i < 16; i++) t += '<circle data-i="' + i + '" r="2.4" fill="#0F172A" opacity="0.18"/>';
      els.trail.innerHTML = t;
      if (state.wind === 'gegenwind' || state.wind === 'rueckenwind') {
        var w = '';
        for (var j = 0; j < 7; j++) w += '<line data-i="' + j + '" stroke="#0F172A" stroke-opacity="0.22" stroke-width="2" stroke-linecap="round"/>';
        els.wind.innerHTML = w;
      } else els.wind.innerHTML = '';
      if (state.temp < 5) {
        var s = '';
        for (var n = 0; n < 30; n++) s += '<circle data-i="' + n + '" r="1.6" fill="#fff" opacity="0.85"/>';
        els.snow.innerHTML = s;
      } else els.snow.innerHTML = '';
    }
    buildScenery();

    function setChip(c, lab, val) {
      var n = els.chips && els.chips.querySelector('[data-c="' + c + '"]');
      if (n) n.innerHTML = '<i>' + lab + '</i>' + val;
    }
    function updateHud() {
      setChip('mode', 'Modus', LABEL_MODE[state.mode] || state.mode);
      setChip('terrain', 'Gelände', LABEL_TERRAIN[state.terrain] || state.terrain);
      setChip('wind', 'Wind', LABEL_WIND[state.wind] || state.wind);
      setChip('temp', 'Temp', state.temp + ' °C');
      setChip('speed', 'Tempo', state.speed + ' km/h');
      if (els.consume) els.consume.innerHTML = '<i>Verbrauch</i>' + (result.whkm != null ? result.whkm : '–') + ' Wh/km';
    }
    updateHud();

    function tick(now) {
      var dt = Math.min(0.05, (now - lastNow) / 1000); lastNow = now;

      // ── Discharge state → battery %, distance, effective speed ──
      var battPct = 1, curSf = sf, kmShown;
      if (mode === 'playing') {
        var p = (now - playStart) / (playDur * 1000);
        if (p >= 1) {
          p = 1; mode = 'done';
          els.play.classList.remove('is-running'); els.play.classList.add('is-done');
          els.play.querySelector('.ic').textContent = '↻';
          els.play.querySelector('.tx').textContent = 'Nochmal';
          els.counterLbl.textContent = 'REICHWEITE ERREICHT';
          els.empty.classList.add('show');
          setLottie(sf * 0.4);
        }
        battPct = 1 - p;
        // letzte ~12 %: viele Motoren drosseln die Unterstützung leicht
        if (mode === 'playing' && p > 0.88) curSf = sf * (0.72 + 0.28 * (1 - (p - 0.88) / 0.12));
        kmShown = Math.round(p * rangeKm());
        showTime('⏱ ' + (p * simHoursTotal).toFixed(1) + ' h · ' + scaleLabel());
      } else if (mode === 'done') {
        battPct = 0; curSf = sf * 0.4; kmShown = rangeKm();
        showTime('⏱ ' + simHoursTotal.toFixed(1) + ' h gefahren · ' + scaleLabel());
      } else {
        var k = Math.min(1, (now - counterStart) / 1100), ease = k * (2 - k);
        kmShown = Math.round(counterFrom + (counterTo - counterFrom) * ease);
      }

      phase += dt * curSf;

      els.ground.setAttribute('d', groundPath(state.terrain, phase));
      els.hills.setAttribute('transform', 'translate(' + (-((phase * 18) % W)).toFixed(1) + ',0)');

      Array.prototype.forEach.call(els.trail.children, function (n) {
        var i = +n.getAttribute('data-i');
        var x = ((i * 70 - phase * 90) % W + W) % W;
        n.setAttribute('cx', x.toFixed(1));
        n.setAttribute('cy', (hillY(state.terrain, x, phase) + 7).toFixed(1));
      });
      Array.prototype.forEach.call(els.wind.children, function (n) {
        var i = +n.getAttribute('data-i');
        var dir = state.wind === 'gegenwind' ? -1 : 1;
        var x = ((i * 150 - dir * phase * 130) % W + W) % W;
        var y = 90 + i * 24;
        n.setAttribute('x1', x.toFixed(1)); n.setAttribute('y1', y);
        n.setAttribute('x2', (x + 56).toFixed(1)); n.setAttribute('y2', y);
      });
      Array.prototype.forEach.call(els.snow.children, function (n) {
        var i = +n.getAttribute('data-i');
        var x = ((i * 53 - phase * 30) % W + W) % W;
        var y = ((i * 31 + phase * 50) % H);
        n.setAttribute('cx', x.toFixed(1)); n.setAttribute('cy', y.toFixed(1));
      });

      // rider follows the hills + tilts to the slope
      var cx = W / 2, ty = hillY(state.terrain, cx, phase);
      var slope = hillY(state.terrain, cx + 45, phase) - hillY(state.terrain, cx - 45, phase);
      var tilt = Math.max(-12, Math.min(12, Math.atan2(slope, 90) * 180 / Math.PI));
      els.rider.style.transform = 'translateX(-50%) translateY(' + (ty - GROUND_Y).toFixed(1) + 'px) rotate(' + tilt.toFixed(2) + 'deg)';

      // battery gauge
      els.battFill.style.width = (battPct * 100).toFixed(1) + '%';
      els.battPct.textContent = Math.round(battPct * 100) + '%';
      els.battPct.style.color = battPct > 0.5 ? '#10B981' : (battPct > 0.2 ? '#F59E0B' : '#EF4444');

      if (els.counterNum.firstChild) els.counterNum.firstChild.nodeValue = kmShown;

      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);

    return {
      update: function (newState, newResult) {
        var rebuild = newState.terrain !== state.terrain || newState.temp !== state.temp || newState.wind !== state.wind;
        state  = Object.assign({}, newState);
        result = Object.assign({}, newResult);
        sf = speedFactorOf(state);
        els.battAkku.textContent = state.akku + ' Wh';
        updateHud();
        if (rebuild) buildScenery();
        resetPlay();   // any input change → reset to a fresh full-battery estimate
      },
      stop: function () { cancelAnimationFrame(raf); if (lottieAnim) { try { lottieAnim.destroy(); } catch (e) {} } }
    };
  }

  return { create: create };
})();
